import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { InputGroup, Input, Icon, HelpBlock } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import CreatePanels from '../../../constants/reservation/CreatePanels';
import { getBarcodeInput } from '../../../redux/selectors/components/guest-search';
import { clearGuests, onChangeBarcodeInput } from '../../../redux/actions';
import { getGuestForBarcode } from '../../../redux/selectors/components/guest-list';
import { switchCreateReservationPanel } from '../../../redux/Reservation/actions/routes/create';

const BarcodeInput = ({ onSubmit, onSwitchSearch, onGuestFound, ...props }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const barcodeInput = useSelector(getBarcodeInput);
  const guest = useSelector(state => getGuestForBarcode(state, barcodeInput));
  const [inputValue, setInputValue] = useState(barcodeInput);

  useEffect(
    () => {
      const guestQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
      if (!get('firstName', guestQuery)) {
        setInputValue('');
        dispatch(clearGuests());
        dispatch(onChangeBarcodeInput(''));
        dispatch(switchCreateReservationPanel(CreatePanels.SEARCH));
      }
    },
    [location]
  );

  useEffect(
    () => {
      if (barcodeInput && guest) {
        onGuestFound(guest);
      }
    },
    [barcodeInput, guest]
  );

  const submitSearch = () => {
    dispatch(onChangeBarcodeInput(inputValue));
    onSubmit({ barcode: inputValue });
  };

  const handleChange = value => {
    setInputValue(value);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') submitSearch();
  };

  const handleKeyDown = e => {
    if (e.key === 'Tab') {
      e.preventDefault();
      onSwitchSearch('columns');
    }
  };

  return (
    <div>
      <InputGroup size="lg" style={{ maxWidth: 400 }}>
        <Input
          {...props}
          value={inputValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onKeyPress={handleKeyPress}
          placeholder="Press Enter or Search icon to submit"
        />
        <InputGroup.Button onClick={submitSearch}>
          <Icon icon="search" />
        </InputGroup.Button>
      </InputGroup>
      <HelpBlock style={{ margin: 3 }}>
        <small>
          <Icon icon="info" /> Type or Scan a barcode
        </small>
      </HelpBlock>
    </div>
  );
};

BarcodeInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSwitchSearch: PropTypes.func.isRequired,
  onGuestFound: PropTypes.func.isRequired
};

export default BarcodeInput;
